module.exports = __webpack_public_path__ + "img/level4.f29be88b.svg";